import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService } from './session.service';
import { _common } from './_common';
import { NgIf } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset.password.sent.component.html',
    standalone: true,
    imports: [FontAwesomeModule, NgIf]
})
export class ResetPasswordSentComponent implements OnInit {

  _common = _common;
  subscription: Subscription;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,

  ) {

  }

  app: string
  mobile = false;
  link = '/'
  ngOnInit() {
    this.subscription = this.route.queryParams.subscribe((params) => {

      this.app = params.app;
      this.mobile = (params.mobile == 'true');

      SessionService.fixTitle(this.app);
      this.link = `/?app=${this.app}`
    })
  }

  title() {
    return document.title;
  }

}
